import { render, staticRenderFns } from "./DeleteCardActions.vue?vue&type=template&id=79739397&"
import script from "./DeleteCardActions.vue?vue&type=script&lang=ts&"
export * from "./DeleteCardActions.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports